import { Store } from 'pullstate'

function getSafeLayout(
  key: string,
  fallback: 'grid' | 'list'
): 'grid' | 'list' {
  const value = localStorage.getItem(key)
  return value === 'grid' || value === 'list' ? value : fallback
}

interface LeaguestarState {
  api_build_timestamp: string
  frontend_build_timestamp: string
  user_id: number
  competition_id: number
  last_updated: string | null
  platforms: { platform_id: number; platform_name: string }[]
  selected_platform_id: number | null
  players_layout: 'grid' | 'list'
  teams_layout: 'grid' | 'list'
}

export const LeaguestarState = new Store<LeaguestarState>({
  api_build_timestamp: '',
  frontend_build_timestamp: process.env.REACT_APP_BUILDTIME || '',
  user_id: 0,
  competition_id: 0,
  last_updated: null,
  platforms: [],
  selected_platform_id: null,
  players_layout: getSafeLayout('players_layout', 'grid'),
  teams_layout: getSafeLayout('teams_layout', 'grid'),
})
